/* eslint-disable no-unused-vars */
/* eslint-disable react/react-in-jsx-scope */
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Space } from 'antd';
import ReactCodeInput from 'react-verification-code-input';
import classNames from 'classnames';
import ButtonLite from 'Components/auth/components/ButtonLite';
import {
  maxMobile,
  maxTablet,
  primaryColor,
  primaryFont,
  primaryHeadingColor,
  SecondaryBgColor,
  SecondaryColorTwo,
  secondaryFont,
  wLight,
  wMBold,
  xmMobile,
} from 'Utils/utilsStyle';
import CrossCircle from 'Components/common/assets/svgIcons/CrossCircle';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'Slice/SettingsSlice';
import { selectSubmitVerificationCodeData, selectSubmitVerificationCodeLoaded } from 'Selector/SettingsSelector';
import InfoIconTwoRed from 'Components/common/assets/svgIcons/InfoIconTwoRed';
import { selectGilroyDiscalimer } from 'Selector/GlobalSearchContentSelector';
import { otherUsersCount, samsungCount } from 'Utils/Constants';
import Email from '../../Components/auth/assets/img/Email.svg';
// import CloseAlerts from '../assets/img/svg/CloseAlerts';
// import InfoIconTwoRed from '../assets/img/svg/InfoIconTwoRed';

const StyleWrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  height: 100vh;
  width: 100%;
  display: flex;
  top: 0;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0px;
  z-index: 100;
  .fancy-box {
    overflow: hidden;
    cursor: default;
    position: relative;
    width: 448px;
    max-width: 100%;
    border-radius: 30px;
    box-shadow: 0 0 60px rgba(0, 0, 0, 0.14);
    background: ${SecondaryBgColor};
    padding: 70px 43px 70px 43px;
    @media all and (max-width: ${maxTablet}) {
      padding: 20px 52px 20px 50px;
    }
    @media all and (max-width: ${maxMobile}) {
      padding: 20px;
      width: 300px;
    }
    .ant-progress{
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      .ant-progress-outer{
        display: flex;
        align-items: center;
        .ant-progress-inner{
          .ant-progress-bg{
            height: 6px !important;
          }
        }
      }
    }
    .description {
      color: ${SecondaryColorTwo};
      font-family: ${primaryFont};
      font-weight: ${wLight};
      font-size: 16px;
      font-style: normal;
      line-height: normal;
      letter-spacing: -0.05px;
      margin: 0 0 48px 0px;
      @media all and (max-width: ${maxTablet}) {
        margin: 0 0 15px 0px;
      }
      @media all and (max-width: ${maxMobile}) {
        font-size: 12px;
      }
    }
    .title-div {
      color: ${primaryHeadingColor};
      font-family: ${secondaryFont};
      font-weight: ${wMBold};
      font-size: 34px;
      font-style: normal;
      line-height: 35px;
      letter-spacing: -0.855px;
      margin: 0 0 16px 0;
      @media all and (max-width: ${maxTablet}) {
        font-size: 32px;
        margin: 0 0 5px 0px;
      }
      @media all and (max-width: ${maxMobile}) {
        font-size: 24px;
        line-height: 25px;
      }
      @media all and (max-width: ${xmMobile}) {
        font-size: 22px;
      }
      span {
        color: ${primaryColor};
        display: flex;
      }
    }
    .img-div {
      margin-bottom: 20px;
      @media all and (max-width: ${maxTablet}) {
        margin-top: 15px;
      }
      @media all and (max-width: ${maxMobile}) {
        margin-bottom: 8px;
      }
      img {
        width: 54px;
        @media all and (max-width: ${maxMobile}) {
          width: 40px;
        }
      }
    }
    .action-div {
      display: flex;
      justify-content: center;
    }
  }
  .validation-input {
    display: flex;
    justify-content: center;
    width: 100% !important;
    input {
      border-color: ${primaryColor};
      caret-color: ${primaryColor};
      font-weight: 900;
      color: #424b50;
      font-family: "Roboto Slab";
      margin: 0px 6.5px;
      border: 2px solid ${primaryColor};
      border-radius: 8px;
      width: 62px !important;
      height: 68px !important;
      padding: 3px !important;
      border-left: 2px solid ${primaryColor} !important;
      border-right: 2px solid ${primaryColor} !important;
      &:focus {
        border: 2px solid ${primaryColor};
      }
      &:first-child{
        margin-left: 0;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        @media all and (max-width: ${maxMobile}) {
          border-top-left-radius: 5px;
          border-bottom-left-radius: 5px;
        }
      }
      &:last-child{
        margin-right: 0;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        @media all and (max-width: ${maxMobile}) {
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
        }
      }
      @media all and (max-width: ${maxTablet}) {
        margin: 0px 4px;
      }

      @media all and (max-width: ${maxMobile}) {
        width: 40px !important;
        height: 40px !important;
        border-radius: 5px;
      }
    }
    &.isLoadingCls{
      input{
        border-color: #D3D3D3;
        border-left: 2px solid #D3D3D3 !important;
        border-right: 2px solid #D3D3D3 !important;
        color: #D3D3D3 !important;
      }
    }
  }
  .expiry-text {
    display: flex;
    justify-content: center;
    width: 100%;
    color: ${primaryHeadingColor};
    font-family: ${primaryFont};
    font-weight: ${wLight};
    text-align: center;
    font-size: 16px;
    margin: 32px 0;
    font-style: normal;
    line-height: normal;
    @media all and (max-width: ${maxTablet}) {
      margin: 20px 0;
    }
    @media all and (max-width: ${maxMobile}) {
      margin: 6px 0;
      font-size: 12px;
      white-space: pre;
    }
  }
  .resendEmailBtn{
    .btn-style{
      border-radius: 100px;
      height: 32px;
      padding: 0 16px;
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 500 !important;
      @media all and (max-width: ${maxMobile}) {
        font-size: 12px;
      }
    }
  }
  .green {
    color: ${primaryColor};
  }
  .disabled {
    pointer-events: none;
    opacity: 0.7;
  }
  .padded-text {
    padding-left: 3px;
    padding-right: 3px;
  }
  .crossIcon {
    position: absolute;
    top: 24px;
    right: 16px;
    height: 32px;
    width: 32px;
    display: flex;
  }
  .pointer {
    cursor: pointer;
  }
  .invalid-code {
    color: #e02020;
    font-family: "Roboto";
    font-weight: 400;
    font-size: 16px;
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: center;
    padding-top: 41px;
  }
  .pt-5 {
    padding-top: 5px;
  }
  .font-14 {
    font-size: 14px !important;
  }
  .m-r-5 {
    margin-right: 5px;
  }
`;

type Props = {
  phone: string;
  description: string;
  onClose: () => void;
  setShowCodeVerificationPopup: (value: boolean) => void
  updateSetting: () => void
};

const CodeVerificationPopup = function CodeVerificationPopup(props: Props) {
  const {
    phone, description, onClose, setShowCodeVerificationPopup, updateSetting,
  } = props;
  const [isTimerExpired, setIsTimerExpired] = useState(false);
  const [code, setCode] = useState('');
  const [isCodeComplete, setIsCodeComplete] = useState(false);
  const isSamsungUser = useSelector(selectGilroyDiscalimer);
  const isSamsung = isSamsungUser.showDisclaimer;
  const [seconds, setSeconds] = useState<number>(0);
  const [isCodeInvalid, setIsCodeInvalid] = useState(false);
  const [intervalId, setIntervalId] = useState<number>(0);
  const [maximumTriesDone, setMaximumTriesDone] = useState(false);
  const dispatch = useDispatch();

  const loaded = useSelector(selectSubmitVerificationCodeLoaded);
  const response = useSelector(selectSubmitVerificationCodeData);
  // const loading = useSelector(selectSubmitVerificationCodeLoading);

  const countDownTimer = () => {
    if (intervalId) clearInterval(intervalId);
    const interval = window.setInterval(() => {
      setSeconds((secondsLapsed) => {
        if (secondsLapsed === 0) {
          clearInterval(interval);
          setIsTimerExpired(true);
          setMaximumTriesDone(false);
          setIsCodeInvalid(false);
          return 0;
        }
        return secondsLapsed - 1;
      });
    }, 1000);
    setIntervalId(interval);
  };

  useEffect(() => {
    if (isSamsung) {
      setSeconds(samsungCount);
    } else {
      setSeconds(otherUsersCount);
    }
  }, []);

  useEffect(() => {
    if (loaded === true && response && response.status === 'True') {
      setShowCodeVerificationPopup(false);
      updateSetting();
    } else if (loaded === true && response && response.status === 'False') {
      if (response.is_button_disabled === true) {
        setMaximumTriesDone(true);
        if (isSamsung) {
          setSeconds(samsungCount);
        } else {
          setSeconds(otherUsersCount);
        }
      }
      setIsCodeInvalid(true);
    }
  }, [loaded, response]);

  useEffect(() => {
    if (isTimerExpired === true) {
      if (isSamsung) {
        setSeconds(samsungCount);
      } else {
        setSeconds(otherUsersCount);
      }
    }
  }, [isTimerExpired]);

  useEffect(() => {
    if (isCodeComplete) {
      dispatch(actions.verifyCode({
        code,
        isSetting: true,
        twoFactorAuthentication: true,
      }));
    }
  }, [code, isCodeComplete]);

  const sendVerificationCodeEmail = () => {
    setIsTimerExpired(false);
    setIsCodeInvalid(false);
    dispatch(actions.sendVerification({
      phone,
      verifyBy: 'sms',
    }));
    countDownTimer();
  };

  useEffect(() => {
    sendVerificationCodeEmail();
  }, []);

  const InvalidCode = (
    <span className="invalid-code pt-5 d-flex align-items-center">
      <InfoIconTwoRed className="m-r-5" />
      Incorrect code. Please try again.
    </span>
  );

  const ExpiredCode = (
    <span className="expiry-text">
      You can resend code now.
    </span>
  );

  const ElapsedTime = (
    <span className="expiry-text">
      Resend Code in
      <b className="padded-text">
        {' '}
        {seconds}
        {' '}
      </b>
      {' '}
      seconds
    </span>
  );

  const MaximumTriesTime = (
    <span className="invalid-code line-block font-14">
      Too many failed attempts. Try again after
      <b className="padded-text">
        {seconds}
      </b>
      {' '}
      seconds
    </span>
  );

  return (
    <StyleWrapper>
      <div
        className="fancy-box"
        onClick={(e) => e.stopPropagation()}
        onKeyPress={(e) => e.stopPropagation()}
        role="button"
        tabIndex={0}
      >

        <CrossCircle
          className="crossIcon pointer"
          onClick={() => onClose()}
        />
        <div className="img-div">
          <img src={Email} alt="email" />
        </div>
        <h4 className="title-div">
          You’re almost there.
          <span className="text-width">Enter Verification code</span>
        </h4>
        <p className="description">{description}</p>
        <ReactCodeInput
          className={classNames('validation-input', { isLoadingCls: false })}
          fields={5}
          onComplete={(input) => {
            setCode(input);
          }}
          onChange={(input) => {
            setIsCodeComplete(input.length === 5);
          }}
        />
        {!maximumTriesDone && (isTimerExpired ? ExpiredCode : ElapsedTime)}
        {isCodeInvalid && !maximumTriesDone && InvalidCode}
        {maximumTriesDone && MaximumTriesTime}

        <div className="action-div">
          <Space>
            {(isTimerExpired) && (
              <ButtonLite
                onClickButton={sendVerificationCodeEmail}
                title="Resend Code"
                className={`resendEmailBtn ${(!isTimerExpired) ? 'disabled' : ''}`}
                outline
              />
            )}
          </Space>
        </div>
      </div>
    </StyleWrapper>
  );
};

export default CodeVerificationPopup;
